import {GetterTree, MutationTree, ActionTree} from 'vuex'
import {UsersState} from '@/store/types'
import axios from 'axios'

type UsersGetter = GetterTree<UsersState, any>
type UsersMutation = MutationTree<UsersState>
type UsersAction = ActionTree<UsersState, any>

const state: UsersState = {
  users: [],
}

const getters: UsersGetter = {
  users: (state) => state.users,
}

const mutations: UsersMutation = {
  setUsers: (state, users) => {
    state.users = users
  },
}

const actions: UsersAction = {
  getUsers: ({commit}) => {
    return new Promise((resolve, reject) => {
      axios.get('users').then((response) => {
        commit('setUsers', response.data.data)
        resolve(response.data.data)
      }).catch((error) => {
        reject(error)
      })
    })
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
